import mixpanel from 'mixpanel-browser'

import Configuration from '@utils/configuration'

const PREFIX = 'ab_training'
const token = Configuration.mixpanelToken
mixpanel.init(token)

window.mixpanel = mixpanel

function prefixId(id) {
  return `${PREFIX}:${id}`
}

function prefixKey(key) {
  return `${PREFIX}_${key}`
}

function isPrefixedId(id) {
  return `${id}`.startsWith(`${PREFIX}:`)
}

function isAnonymousId(id) {
  const deviceId = mixpanel.cookie.props.$device_id

  return id === deviceId
}

export const identify = (uniqueId) => {
  const distinctId = prefixId(uniqueId)
  const currentDistinctId = mixpanel.get_distinct_id()

  const alreadyIdentified = distinctId === currentDistinctId
  const hasIdForDifferentUser = !alreadyIdentified && isPrefixedId(currentDistinctId)
  const hasExchangeCompareId = !hasIdForDifferentUser && !isAnonymousId(currentDistinctId)

  if (alreadyIdentified) {
    return
  }

  if (hasExchangeCompareId) {
    mixpanel.identify(currentDistinctId)
    mixpanel.alias(distinctId, currentDistinctId)
    return
  }

  if (hasIdForDifferentUser) {
    mixpanel.reset()
  }

  mixpanel.identify(distinctId)
}

export const track = (eventName, properties = {}) => {
  const prefixedEventName = `${PREFIX}:${eventName}`

  mixpanel.track(prefixedEventName, properties)
}

export const updateProfile = (profile) => {
  const prefixedProfile = {}

  Object.keys(profile).forEach((key) => {
    const prefixedKey = prefixKey(key)
    prefixedProfile[prefixedKey] = profile[key]
  })

  mixpanel.people.set(prefixedProfile)
}
